import { render } from "./BadScoreAddModal.vue?vue&type=template&id=26cd5ffd&scoped=true"
import script from "./BadScoreAddModal.vue?vue&type=script&lang=js"
export * from "./BadScoreAddModal.vue?vue&type=script&lang=js"

import "./BadScoreAddModal.vue?vue&type=style&index=0&id=26cd5ffd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cd5ffd"]])

export default __exports__